<app-page>
  <post-thread></post-thread>
</app-page>
